import validate from "/workd/WORKD/PROJECT_2025/IKAMAI/LIVE/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/workd/WORKD/PROJECT_2025/IKAMAI/LIVE/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/workd/WORKD/PROJECT_2025/IKAMAI/LIVE/node_modules/.c12/gitlab_ikamai_nuxt_zrArIKnFUe/middleware/auth.ts")
}